const initialState = {
    pending: false,
    companies: [],
    page: 0,
    itemsCount: 0,
    pageCount: 0,
    error: null,
    filters: {active: 'ALL', itemsPerPage: 10, search: ''},
    selected: {}
};

const companiesReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'GET_COMPANIES_PENDING':
            return {
                ...state,
                pending: true
            };
        case 'GET_COMPANIES_SUCCESS':
            return {
                ...state,
                pending: false,
                companies: action.companies,
                page: action.page,
                pageCount: action.pageCount,
                itemsCount: action.itemsCount
            };
        case 'GET_COMPANIES_ERROR':
            return {
                ...state,
                pending: false,
                error: action.error
            };
        case 'SELECT_COMPANY':
            return {
                ...state,
                selected: action.selected
            };
        case 'SET_COMPANIES_FILTERS':
            return {
                ...state,
                filters: action.filters
            };
        case 'ADD_COMPANY_SUCCESS':
            return {
                ...state,
                pending: false
            };
        default:
            return state;
    }
};

export default companiesReducer;
